import { render, staticRenderFns } from "./ProductCardComponent.vue?vue&type=template&id=5ceeb584"
import script from "./ProductCardComponent.vue?vue&type=script&lang=js"
export * from "./ProductCardComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductCardComponent.vue?vue&type=style&index=0&id=5ceeb584&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports